import * as React from "react";

const SvgIcon = ({props,size='28'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="SvgjsSvg1014"
    width={size}
    height={size}
    version="1.1"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="SvgjsG1016"
      width={size}
      height={size}
      viewBox="0 0 128 128"
    >
      <path
        fill="#155eef"
        d="M80.016 96h-8.297L63.75 83.039 55.781 96H48l11.367-17.672-10.64-16.594h8.016l7.383 12.328 7.242-12.328h7.828L68.438 78.727zM104 80c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m10.882 16.988-.113.176-8.232 11.438c-.548.866-1.508 1.398-2.537 1.398s-1.989-.532-2.536-1.397l-8.346-11.614a3.01 3.01 0 0 1 .01-2.994 3.01 3.01 0 0 1 2.596-1.494H100V86c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v6.5h4.276c1.065 0 2.061.572 2.596 1.494a3.01 3.01 0 0 1 .01 2.994"
        className="svgShape color007732-0 selectable"
      ></path>
      <path
        fill="#fff"
        d="m84 125.95-.05.05H84zM114 77v-.05l-.05.05z"
        className="svgShape colorff9a30-1 selectable"
      ></path>
      <path
        fill="#155eef"
        d="M111.071 44.243 71.757 4.929A9.94 9.94 0 0 0 64.687 2H24c-5.514 0-10 4.486-10 10v104c0 5.514 4.486 10 10 10h59.95l-4-4H24c-3.309 0-6-2.691-6-6V12c0-3.309 2.691-6 6-6h40.687c1.603 0 3.109.624 4.242 1.757l39.314 39.314A6.04 6.04 0 0 1 110 51.313V72.95l4 4V51.313c0-2.67-1.04-5.181-2.929-7.07"
        className="svgShape color007732-2 selectable"
      ></path>
      <path
        fill="#fff"
        d="m113.95 77 .05-.05-4-4"
        className="svgShape colorffffff-3 selectable"
      ></path>
    </svg>
  </svg>
);

export default SvgIcon;
